<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="contact-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Contexte du <span *ngIf="round.firstRound">1er tour</span><span
            *ngIf="!round.firstRound">2nd tour</span></p>
      </div>
    </div>
  </div>

  <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;" id="information-grid" class="p-20">

    <div *ngIf="round.firstRound else secondRound">
      <div class="flex gap-20 mb-10">
        <label class="flex align-items-center gap-10">
          <input type="radio" name="isRenew" [value]="true" [(ngModel)]="electionContext.setup"
            (ngModelChange)="onRoundChange()">
          <span>Mise en place</span>
        </label>
        <label class="flex align-items-center gap-10">
          <input type="radio" name="isRenew" [value]="false" [(ngModel)]="electionContext.setup"
            (ngModelChange)="onRoundChange()">
          <span>Renouvellement</span>
        </label>
      </div>

      <div class="flex gap-20" *ngIf="!electionContext.setup">
        <div>
          <p class="dark-blue no-margin">Expiration des mandats <span class="red">*</span></p>
          <div class="mb-10">
            <input type="date" name="first_open" id="first_open" class="text-md dark-blue pap-input w-full"
              [(ngModel)]="fROpeningString" (ngModelChange)="onContextChange()">
          </div>
        </div>
        <div></div>
      </div>
    </div>

    <ng-template #secondRound>
      <div>
        <div class="flex gap-20">
          <label class="flex align-items-center gap-10">
            <input type="radio" name="quorum" [value]="true" [(ngModel)]="electionContext.noQuorum"
              (ngModelChange)="onRoundChange()">
            <span>Quorum non atteint</span>
          </label>
          <label class="flex align-items-center gap-10">
            <input type="radio" name="remainingSeats" [value]="false" [(ngModel)]="electionContext.noQuorum"
              (ngModelChange)="onRoundChange()">
            <span>Sièges restants à pourvoir</span>
          </label>
        </div>


        <div *ngIf="!electionContext.noQuorum" class="mt-20"
          style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px;">
          <div>
            <p class="dark-blue no-margin">Sièges titulaires <span class="red">*</span></p>
            <input type="number" min="0" name="secondTurnSeats" id="secondTurnSeats"
              class="w-full text-md dark-blue pap-input" value="0" (wheel)="$event.preventDefault()">
          </div>

          <div>
            <p class="dark-blue no-margin">Sièges suppléants <span class="red">*</span></p>
            <input type="number" min="0" name="secondTurnSubstituteSeats" id="secondTurnSubstituteSeats"
              class="w-full text-md dark-blue pap-input" value="0" (wheel)="$event.preventDefault()">
          </div>
        </div>
      </div>

    </ng-template>
  </div>

  <div>

  </div>
</div>